/**
 * CTAButton — main call-to-action button for Kupon Conversion template.
 * Wired to project checkout flow: addToCart → navigate to /checkout/pengiriman
 */

const sizes = {
  md: "px-6 py-3 text-sm",
  lg: "px-8 py-4 text-base",
  xl: "px-10 py-5 text-lg md:text-xl",
};

const variants = {
  primary:
    "bg-gradient-primary text-primary-foreground shadow-luxury hover:brightness-110 active:scale-[0.98]",
  outline:
    "bg-white text-primary border-2 border-primary hover:bg-primary hover:text-primary-foreground",
  "ghost-light":
    "bg-white/15 backdrop-blur-md text-white border border-white/40 hover:bg-white hover:text-primary",
};

export default function CTAButton({
  children,
  variant = "primary",
  size = "lg",
  className = "",
  pulse = false,
  fullWidth = false,
  onClick,
  disabled = false,
}) {
  return (
    <button
      type="button"
      onClick={onClick}
      disabled={disabled}
      className={[
        "inline-flex items-center justify-center gap-2 rounded-full font-bold tracking-wide uppercase transition-all duration-300 cursor-pointer disabled:opacity-50 disabled:cursor-not-allowed",
        sizes[size] || sizes.lg,
        variants[variant] || variants.primary,
        pulse ? "animate-pulse-glow" : "",
        fullWidth ? "w-full" : "",
        className,
      ].join(" ")}
    >
      {children}
    </button>
  );
}
